import { Row, Text } from '@app/components'
import { walletConnect, walletConnectHooks } from '@app/services'
import { useEffect, useState } from 'react'

import { WalletConnectIcon } from '~public'

import { StyledWalletCard } from './elements'

const { useIsActivating } = walletConnectHooks

export const WalletConnectCard: React.FC = () => {
  const isActivating = useIsActivating()
  const connector = walletConnect
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState(undefined)

  // attempt to connect eagerly on mount. DONT NEED THIS AT THE MOMENT
  useEffect(() => {
    // walletConnect.connectEagerly().catch(() => {
    //   // eslint-disable-next-line no-console
    //   console.debug('Failed to connect eagerly to walletconnect')
    // })
  }, [])

  const handleOnClick = () => {
    if (isActivating) return
    connector
      .activate(parseInt(process.env.NEXT_PUBLIC_PULSECHAIN))
      .then(() => setError(undefined))
      .catch(setError)
  }

  return (
    <StyledWalletCard onClick={handleOnClick}>
      <Row justify={'center'}>
        <WalletConnectIcon />
      </Row>
      <Row justify={'center'}>
        <Text>Wallet Connect</Text>
      </Row>
    </StyledWalletCard>
  )
}
